import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { AnyAction } from 'redux';

import * as constants from 'redux/constants/persons.constants';
import { getAll, getForm, getOne, save, softDelete } from 'services/persons.services';

export function* personsDelete(action: AnyAction): Generator {
  try {
    const { id }: any = action;
    const { data }: any = yield call(softDelete, id);
    yield put({
      type: constants.PERSONS_ON_DELETE_SUCCEEDED,
      data: { ...data, id },
    });
  } catch (error) {
    yield put({ type: constants.PERSONS_ON_DELETE_FAILED, error });
  }
}

export function* personsGetAll(action: AnyAction): Generator {
  try {
    const { limit, page, search, sortKey, sortType } = action;
    const { data }: any = yield call(getAll, limit, page, search, sortKey, sortType);
    yield put({ type: constants.PERSONS_ON_GET_ALL_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.PERSONS_ON_GET_ALL_FAILED, error });
  }
}

export function* personsGetForm(): Generator {
  try {
    const { data }: any = yield call(getForm);
    yield put({ type: constants.PERSONS_ON_GET_FORM_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.PERSONS_ON_GET_FORM_FAILED, error });
  }
}

export function* personsGetOne(action: AnyAction): Generator {
  try {
    const { id }: any = action;
    if (id) {
      const { data }: any = yield call(getOne, id);
      yield put({ type: constants.PERSONS_ON_GET_ONE_SUCCEEDED, data });
    }
  } catch (error) {
    yield put({ type: constants.PERSONS_ON_GET_ONE_FAILED, error });
  }
}

export function* personsSave(action: AnyAction): Generator {
  try {
    const { formData, id } = action;
    const { data }: any = yield call(save, formData, id);
    yield put({ type: constants.PERSONS_ON_SAVE_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.PERSONS_ON_SAVE_FAILED, error });
  }
}

export function* personsRefresh(): Generator {
  const table: any = yield select((state) => state.persons.table);
  yield put({ type: constants.PERSONS_ON_GET_ALL_REQUESTED, ...table });
}

export function* watchPersons(): Generator {
  yield all([
    takeLatest(constants.PERSONS_ON_DELETE_REQUESTED, personsDelete),
    takeLatest(constants.PERSONS_ON_GET_ALL_REQUESTED, personsGetAll),
    takeLatest(constants.PERSONS_ON_GET_FORM_REQUESTED, personsGetForm),
    takeLatest(constants.PERSONS_ON_GET_ONE_REQUESTED, personsGetOne),
    takeLatest(constants.PERSONS_ON_SAVE_REQUESTED, personsSave),
    takeLatest(
      [constants.PERSONS_ON_DELETE_SUCCEEDED, constants.PERSONS_ON_SAVE_SUCCEEDED],
      personsRefresh,
    ),
  ]);
}
